import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_form, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_v_text_field, {
            modelValue: _ctx.inputHour,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputHour) = $event)),
            rules: [_ctx.isHour],
            variant: "outlined",
            density: "compact",
            "hide-details": "",
            suffix: "時",
            type: "number",
            color: "primary"
          }, null, 8, ["modelValue", "rules"]),
          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "ma-2 align-center" }, ":", -1)),
          _createVNode(_component_v_text_field, {
            modelValue: _ctx.inputMinute,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputMinute) = $event)),
            rules: [_ctx.isMinute],
            variant: "outlined",
            density: "compact",
            "hide-details": "",
            suffix: "分",
            type: "number",
            color: "primary"
          }, null, 8, ["modelValue", "rules"])
        ])
      ]),
      _: 1
    })
  ]))
}